import * as React from 'react';
import { EditState, EditProps, BaseRouteProps } from '../../interfaces';
import { Style } from '../../models';
import { StyleDataService } from '../../services';
import { NavLink } from 'react-router-dom';
import { StyleForm } from './StyleForm';
import { LoadingIndicator, PVAPage } from '../../components';

export class StyleEdit extends React.Component<BaseRouteProps<EditProps>, EditState<Style>> {
    private styleDataService = new StyleDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<EditProps>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public render() {
        if (!this.state.originalEntity) {
            return <LoadingIndicator />;
        }

        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Buttons>
                        <NavLink to={'/surveyversion/' + this.state.originalEntity.surveyVersionID + '/styles'}>
                            <span className="glyphicon glyphicon-arrow-left" />
                        </NavLink>
                    </PVAPage.Header.Buttons>
                    <div className="title">
                        Edit Style
                        <span className="light"> &nbsp; This is the PVA Style that gets assigned to a user based on their assessment results.</span>
                    </div>
                </PVAPage.Header>

                <PVAPage.Body>
                    <StyleForm defaultValues={this.state.originalEntity} submit={this.save} surveyVersionId={this.state.originalEntity.surveyVersionID} notificationService={this.props.notificationService} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    public componentDidMount() {
        const id = this.props.match.params.id;

        if (id) {
            this.styleDataService.get(id).then((style: Style) => {
                style.styleConstraints = style.styleConstraints || [];
                this.setState({ originalEntity: style });
            });
        }
    }

    private save(values: any) {
        this.styleDataService.update(values).then((success) => {
            // this.props.history.push('/surveyversion/' + t);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/style/StyleEdit.tsx